import request from '../../../../api/api';

function getDateString(date) {
    const dt = (('0' + date.getDate()).slice(-2));
    const month = (('0' + (date.getMonth() + 1)).slice(-2));

    return dt + '.' + month + '.' + date.getFullYear();
}

export default function CreateReport(id, type, begin, end) {
    return dispatch => {
        return request('/v1/orders/food/get_order_list?object_id=' +
        id + '&object_type=' + type + '&period_begin=' + getDateString(begin) + '&period_end=' + getDateString(end)
        ).then(
            data => {
                dispatch({
                    type: 'HISTORY_ACTION',
                    payload: {
                        history: data.data.orderList,
                        total: data.data.ordersTotal,
                        error: data.data.orderList.length ? '' : 'Нет заказов за выбранный период'
                    }
                });
            },
            error => {
                if (error.data && error.data.returnCode === 0) {
                    dispatch({
                        type: 'HISTORY_ACTION',
                        payload: {
                            history: [],
                            error: error.data.error
                        },
                    });

                    return null;
                } else return Promise.reject(error);
            }
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/modules/food/actions/history/CreateReport.js
 **/